<template>
    <div>
        <nav class="navbar navbar-dark fixed-top  flex-md-nowrap p-0 shadow">
            <router-link class="navbar-brand col-sm-3 col-md-2 mr-0" href="#" to='/'>Pure Savon</router-link>
            <ul class="navbar-nav px-3">
                <li class="nav-item text-nowrap">
                <a class="nav-link" href="#" @click.prevent='logout'><i class="fas fa-sign-out-alt"></i>登出</a>
                </li>
            </ul>
        </nav>
    </div>
</template>
<script>
export default {
  name: 'Navbar',
  methods: {
    logout () {
      const vm = this
      const api = `${process.env.VUE_APP_APIPATH}/logout`
      this.$http.post(api).then((response) => {
        console.log(response.data)
        if (response.data.success) {
          vm.$router.push('/login')
        }
      })
    }
  }
}
</script>
<style scoped>
.navbar{
    background-color:#34495E;
}
</style>
